
const {
    enum_costCurrency_n,
    enum_lockTypes,
    enum_questTypes,
    enum_timeUnits,
    enum_questTicketStatus,
    enum_questEventStartClockTypes_s, enum_banks_n,
    enum_questPermission_n, enum_langCodes, enum_availableTicketsTypes_s} = require( './Share_S_Enum');
const {validator_array_fb} = require( "./Share_S_Validator");
const {ass_strings} = require( "./Share_Ass_Dictionary");
const {Cla_AppVersion} = require( "./Share_S_Classes");
const {gv_numbers} = require( "./Share_Ass_GlobalVariable");

// format_cost_range
export const format_costRange_s = (costMin_n, costMax_n, currency_e, displayLangCode_e) =>{

    if (costMax_n <= 0){
        return ass_strings.oneWord_Free[displayLangCode_e]
    }

    if(costMin_n === costMax_n)
        return `${costMax_n.toFixed(0)}${format_costCurrency(currency_e)}`
    else
        return `${costMin_n.toFixed(0)}-${costMax_n.toFixed(0)}${format_costCurrency(currency_e)}`

}

// formatCost_s
export const format_cost_s = (cost_c, discountPercentage_n = null) => {
    // if (cost_c.c_value_n <= 0)
    //     return "Free"

    let cost_n =  cost_c.c_value_n

    if(discountPercentage_n > 0){
        cost_n = cost_n - (cost_n * discountPercentage_n / 100)
    }

    return '' + cost_n + format_costCurrency(cost_c.c_currency_e)
}

// format_costCurrency
export const format_costCurrency = (currency) => {
    switch (currency){
        case enum_costCurrency_n.SHEKEL:
            return "₪"
        case enum_costCurrency_n.DOLLAR:
            return "$"
        case enum_costCurrency_n.EURO:
            return "€"
        default:
            return "₪"
    }

}

// format_langCode_fs
export const format_langCode_fs = (languageCode) => {
    switch (languageCode) {
        case enum_langCodes.hebrew:
            return "עברית"
        case enum_langCodes.english:
            return 'English'
        case enum_langCodes.french:
            return 'Français'
        case enum_langCodes.spanish:
            return 'Español'
        case enum_langCodes.arabic:
            return 'عربيه'
        case enum_langCodes.dutch:
            return 'Dutch'
        default:
            return ''
    }
}

// format_bankNumber_s
export const format_bankNumber_s = (bank_en, langCode_e) => {
    switch (bank_en) {
        case enum_banks_n.Discount:
            return `${ass_strings.oneWord_Discount[langCode_e]} (${bank_en})`
        case enum_banks_n.Mercantile:
            return `${ass_strings.oneWord_Mercantile[langCode_e]} (${bank_en})`
        case enum_banks_n.Hapoalim:
            return `${ass_strings.oneWord_Hapoalim[langCode_e]} (${bank_en})`
        case enum_banks_n.Leumi:
            return `${ass_strings.oneWord_Leumi[langCode_e]} (${bank_en})`
        case enum_banks_n.MizrahiTefahot:
            return `${ass_strings.twoWords_MizrahiTefahot[langCode_e]} (${bank_en})`
        case enum_banks_n.OtsarHaHayal:
            return `${ass_strings.twoWords_OtsarHaHayal[langCode_e]} (${bank_en})`
        case enum_banks_n.Yahav:
            return `${ass_strings.oneWord_Yahav[langCode_e]} (${bank_en})`
        case enum_banks_n.fibi:
            return `${ass_strings.oneWord_fibi[langCode_e]} (${bank_en})`
        default:
            return ""
    }
}

// format_questPermission_s
export const format_questPermission_s = (questPermission_n, langCode_e) => {
    switch (questPermission_n) {
        case enum_questPermission_n.none:
            return ass_strings.twoWords_noAccess[langCode_e]
        case enum_questPermission_n.guide:
            return ass_strings.oneWord_guide[langCode_e]
        case enum_questPermission_n.editor:
            return ass_strings.oneWord_editor[langCode_e]
        case enum_questPermission_n.admin:
            return ass_strings.oneWord_admin[langCode_e]
        case enum_questPermission_n.owner:
            return ass_strings.oneWord_owner[langCode_e]

        default:
            return "-"
    }
}

// format_langArrCode
export const format_langArrCode = (langArr) => {

    let ans = ""
    if (!validator_array_fb(langArr)) {
        return ans
    }

    for (let i=0; i< langArr.length; i++) {

        ans += format_langCode_fs(langArr[i])
        if (i + 1 < langArr.length)
            ans += ', '
    }

    return ans

}

// format_strMaxLength_s
export const format_strMaxLength_s = (str_s, maxLength_n) => {

    if(str_s == null){return ""}

    if (str_s.length > maxLength_n) {
        return str_s.substring(0, maxLength_n) + "..."
    } else {
        return str_s
    }
}

// format_shareNum_fs
export const format_shareNum_fs = (num_n) => {

    if (num_n > 1000000) {
        return num_n / 1000000 + 'M'
    } else if (num_n > 1000) {
        return num_n / 1000 + 'k'
    }
    return num_n
}

// format_questType
export const format_questType = (questType) => {


    switch (questType) {

        case enum_questTypes.CARDS:
            return "Cards"

        case  enum_questTypes.OPEN_MAP:
            return "Open Map"

        case  enum_questTypes.MISSIONS:
            return "Missions"

        default:
            return null
    }

}

// format_lockType_fs
export const format_lockType_fs = (lockType, langCode) => {


    switch (lockType) {
        case enum_lockTypes.IMAGE:
            return ass_strings.oneWord_image[langCode]
        case enum_lockTypes.OPTIONS:
            return ass_strings.oneWord_options[langCode]
        case enum_lockTypes.WORDS:
            return ass_strings.oneWord_text[langCode]
        case enum_lockTypes.INCLUDE_WORD:
            return ass_strings.twoWords_includesWord[langCode]
        case enum_lockTypes.VIDEO:
            return ass_strings.oneWord_video[langCode]

        case enum_lockTypes.QR_CODE:
            return ass_strings.twoWords_QRCode[langCode]

        case enum_lockTypes.QUIZ:
            return ass_strings.oneWord_quiz[langCode]

        case enum_lockTypes.IMAGE_WITHOUT_APPROVED:
            return ass_strings.threeWords_ImageWithoutApprove[langCode]
    }

}

// format_percentage
export const format_percentage = (num) => {

    return Math.round((num * 100)) + '%'
}

// format_currentVersion
export const format_currentVersion = (version_cla) => {

    let version = new Cla_AppVersion(version_cla)
    return version.version
}

// format_sizeBytes_s
export const format_sizeBytes_s = (sizeBytes) => {

    let sizes_as = ['Bytes', "KB", "MB", "GB"]
    let sizeIndex = 0

    while (sizeBytes > 1000) {
        sizeIndex++;
        sizeBytes = sizeBytes / 1000
    }

    return sizeBytes.toFixed(0) + sizes_as[sizeIndex]
}

// format_changeUnit
export const format_changeUnit = (time, fromUnit, toUnit) => {

    let priority = {
        [enum_timeUnits.days]: 5,
        [enum_timeUnits.hours]: 4,
        [enum_timeUnits.minutes]: 3,
        [enum_timeUnits.seconds]: 2,
        [enum_timeUnits.milliseconds]: 1,
    }


    let op = '/'

    if (priority[fromUnit] > priority[toUnit]) {
        let temp = fromUnit
        fromUnit = toUnit
        toUnit = temp
        op = '*'
    }

    switch (fromUnit) {
        case enum_timeUnits.hours:
            switch (toUnit) {
                case enum_timeUnits.days:
                    time = eval(time + op + 24)
            }

            break;
        case enum_timeUnits.minutes:
            switch (toUnit) {
                case enum_timeUnits.days:
                    time = eval(time + op + 24)
                case enum_timeUnits.hours:
                    time = eval(time + op + 60)
            }

            break;
        case enum_timeUnits.seconds:

            switch (toUnit) {
                case enum_timeUnits.days:
                    time = eval(time + op + 24)
                case enum_timeUnits.hours:
                    time = eval(time + op + 60)
                case enum_timeUnits.minutes:
                    time = eval(time + op + 60)
            }
            break;
        case enum_timeUnits.milliseconds:

            switch (toUnit) {
                case enum_timeUnits.days:
                    time = eval(time + op + 24)
                case enum_timeUnits.hours:
                    time = eval(time + op + 60)
                case enum_timeUnits.minutes:
                    time = eval(time + op + 60)
                case enum_timeUnits.seconds:
                    time = eval(time + op + gv_numbers.millisecondsInSecond)
            }
            break;
    }

    return parseInt(time)

}

// format_shortKey_fs
export const format_shortKey_fs = (shortKey ) => {

    [2,3,4,7,8,9].forEach( spaceIndex_n => {

        if(shortKey[spaceIndex_n] == null){
            return
        }

        let spaceChar_s = [3,8].includes(spaceIndex_n) ? "-" : " "

        if(shortKey[spaceIndex_n] !== spaceChar_s){
            shortKey = shortKey.substring(0, spaceIndex_n) + spaceChar_s + shortKey.substring(spaceIndex_n)
        }
    })



    if(shortKey.length < 10 ){
        shortKey = shortKey.substring(0,7)
    }

    if(shortKey.length < 6 ){
        shortKey = shortKey.substring(0,2)
    }

    if(shortKey.length > 12){
        shortKey = shortKey.substring(0,12)
    }

    return shortKey
}

// format_status_fs
export const format_ticketStatus_fs = (status_e , langCode_e ) => {

    switch(status_e){
        case enum_questTicketStatus.approved:
            return ass_strings.oneWord_approved[langCode_e]

        case enum_questTicketStatus.charged:
            return ass_strings.oneWord_charged[langCode_e]

        case enum_questTicketStatus.waitingToApprove:
            return ass_strings.threeWords_waitingToApprove[langCode_e]

        case enum_questTicketStatus.expired:
            return ass_strings.oneWord_expired[langCode_e]

        case enum_questTicketStatus.canceled:
            return ass_strings.oneWord_canceled[langCode_e]

        case enum_questTicketStatus.creatorRequest:
            return ass_strings.threeWords_waitingToApprove[langCode_e]

        case enum_questTicketStatus.creatorRequestApproved:
            return ass_strings.oneWord_approved[langCode_e]

        case enum_questTicketStatus.creatorRequestDecline:
            return ass_strings.oneWord_decline[langCode_e]

    }

}

// format_ticketType_fs
export const format_ticketType_fs = (ticketType_e , langCode_e ) => {

    switch(ticketType_e){
        case enum_availableTicketsTypes_s.gradualTicket:
            return ass_strings.twoWords_gradualTickets[langCode_e]
        case enum_availableTicketsTypes_s.specificTicket:
            return ass_strings.twoWords_specificTicket[langCode_e]
    }

}

// format_clockType_f
export const format_clockType_f = (eventStartClockType_e, langCode_e)=> {

    switch(eventStartClockType_e){
        case enum_questEventStartClockTypes_s.creatorStartClock:
            return ass_strings.fourWords_creatorStartEventClock[langCode_e]
        case enum_questEventStartClockTypes_s.playerStartClock:
            return ass_strings.fourWords_playerStartTeamClock[langCode_e]
        case enum_questEventStartClockTypes_s.eventStartClock:
            return ass_strings.fourWords_eventStartEventClock[langCode_e]
    }
}

// ========= format date ==============

// format_date_YYYY_MM_DD_fs
export const format_date_YYYY_MM_DD_fs = (date_t, utcOffset_n) => {
    let date = new Date(date_t);

    if(utcOffset_n != null){
        date.setHours(date.getHours() + (utcOffset_n - date.getTimezoneOffset()*-1 /60))
    }

    let dd = date.getDate();
    let MM = date.getMonth() + 1; //January is 0!
    let yyyy = date.getFullYear();

    return `${addZero_s(dd)}.${addZero_s(MM)}.${yyyy}`
}

// format_date_YYYY_MM_fs
export const format_date_YYYY_MM_fs = (date_t, utcOffset_n) => {
    let date = new Date(date_t);

    if(utcOffset_n != null){
        date.setHours(date.getHours() + (utcOffset_n - date.getTimezoneOffset()*-1 /60))
    }

    let MM = date.getMonth() + 1; //January is 0!
    let yyyy = date.getFullYear();

    return `${yyyy}-${addZero_s(MM)}`
}


// format_date_YYYY_MM_DD_hh_mm_fs
export const format_date_YYYY_MM_DD_hh_mm_fs = (date_t, utcOffset_n) => {

    if(date_t == null){return ""}

    let date = new Date(date_t);

    if(utcOffset_n != null){
        date.setHours(date.getHours() + (utcOffset_n - date.getTimezoneOffset()*-1 /60))
    }

    let dd = date.getDate();
    let MM = date.getMonth() + 1; //January is 0!
    let hh = date.getHours();
    let mm = date.getMinutes();
    let yyyy = date.getFullYear();


    return ` ${addZero_s(hh)}:${addZero_s(mm)} ${addZero_s(dd)}/${addZero_s(MM)}/${yyyy}`
}

// format_date_hh_mm_fs
export const format_date_hh_mm_fs = (timestamp_t) => {

    if (timestamp_t == null)
        return
    let date = new Date(Number.parseInt(timestamp_t))

    let hh = date.getHours();
    let mm = date.getMinutes();

    return `${addZero_s(hh)}:${addZero_s(mm)}`

}

// format_dateInput_fs
export const format_date_input_fs = (timestamp_t) => {
    let date = new Date(timestamp_t);
    let dd = date.getDate();
    let MM = date.getMonth() + 1; //January is 0!

    let yyyy = date.getFullYear();
    return `${yyyy}-${addZero_s(MM)}-${addZero_s(dd)}`
}

// format_date_inputHour_fs
export const format_date_inputHour_fs = (timestamp_t) => {
    let date = new Date(timestamp_t);

    let hh = date.getHours();
    let mm = date.getMinutes();

    return `${addZero_s(hh)}:${addZero_s(mm)}`
}

// format_date_inputHour_fs
export const format_bigNumber_fs = (number_n) => {

    if(number_n > 1000000){
        return (number_n/1000000).toFixed(0) + 'm+'
    }if(number_n > 1000){
        return (number_n/1000).toFixed(0) + 'k+'
    }else{
        return number_n + ''
    }
}


// format_duration
export const format_duration_minutes = (durationInMinutes_n, langCode) => {

    let days = Math.floor(durationInMinutes_n / 60 / 24)
    let hours = Math.floor(durationInMinutes_n / 60 % 24)

    let minutes = durationInMinutes_n % 60

    if (days > 0) {
        if (hours === 0 && minutes === 0) {
            return `${addZero_s(days)} ${ass_strings.oneWord_days[langCode]}`
        } else {
            return `${addZero_s(days)} ${ass_strings.oneWord_days[langCode]} ${addZero_s(hours)}:${addZero_s(minutes)} ${ass_strings.oneWord_hours[langCode]}`
        }

    } else {
        return `${addZero_s(hours)}:${addZero_s(minutes)} ${ass_strings.oneWord_hours[langCode]}`
    }
}
export const format_duration_dayshhmmss = (durationInMilliseconds_n, system_langCode_e) => {

    let days = addZero_s(
        format_changeUnit(durationInMilliseconds_n, enum_timeUnits.milliseconds, enum_timeUnits.days))
    let hours = addZero_s(
        format_changeUnit(durationInMilliseconds_n, enum_timeUnits.milliseconds, enum_timeUnits.hours)
        % 24);
    let minutes = addZero_s(
        format_changeUnit(durationInMilliseconds_n, enum_timeUnits.milliseconds, enum_timeUnits.minutes)
        % 60);
    let seconds = addZero_s(
        format_changeUnit(durationInMilliseconds_n, enum_timeUnits.milliseconds, enum_timeUnits.seconds)
        % 60);

    if (days === '00') {
        return `${hours}:${minutes}:${seconds}`
    }

    return `${days} ${ass_strings.oneWord_days[system_langCode_e]} ${hours}:${minutes}:${seconds}`
}
export const format_duration_hhmmss = (durationInMilliseconds_n) => {

    let hours = addZero_s(format_changeUnit(durationInMilliseconds_n, enum_timeUnits.milliseconds, enum_timeUnits.hours));
    let minutes = addZero_s(
        format_changeUnit(durationInMilliseconds_n, enum_timeUnits.milliseconds, enum_timeUnits.minutes)
        % 60);
    let seconds = addZero_s(
        format_changeUnit(durationInMilliseconds_n, enum_timeUnits.milliseconds, enum_timeUnits.seconds)
        % 60);


    return `${hours}:${minutes}:${seconds}`
}

export const format_date_yyyy_month_fs = (date_d, langCode_e) => {

    let monthNames = [
        ass_strings.oneWord_January,    ass_strings.oneWord_February, ass_strings.oneWord_March, ass_strings.oneWord_April, ass_strings.oneWord_May,
        ass_strings.oneWord_June,       ass_strings.oneWord_July, ass_strings.oneWord_August, ass_strings.oneWord_September, ass_strings.oneWord_October,
        ass_strings.oneWord_November,   ass_strings.oneWord_December,
    ]

    return `${date_d.getFullYear()} ${monthNames[date_d.getMonth()][langCode_e]}`
}


// ========= localFunctions ============

// addZero_s
const addZero_s = (num ) => {

    if(num < 10){
        return '0' + num
    }else{
        return '' + num
    }
}